import React from 'react'

import CommonButton from 'components/buttons/CommonButton/CommonButton'
import Message from 'components/text/Message/Message'

import s from './Mobile.scss'


const ConfirmModalMobile = (props) => {
  const {
    children, confirmTitle, cancelTitle, withTextCancel, confirmTestId, cancelTestId,
    onConfirm, onCancel,
  } = props

  return (
    <div>
      {children}
      <CommonButton
        className={s.confirmButton}
        title={confirmTitle}
        brand
        confirm
        fullWidth
        onClick={onConfirm}
        dataTestId={confirmTestId}
      />
      {
        withTextCancel ? (
          <Message
            className={s.textCancel}
            name="components.modal.ConfirmModal"
            text={cancelTitle}
            onClick={onCancel}
            dataTestId={cancelTestId}
            html
          />
        ) : (
          <div className={s.footer}>
            <CommonButton
              title={cancelTitle}
              emptyGray
              back
              fullWidth
              onClick={onCancel}
              dataTestId={cancelTestId}
            />
          </div>
        )
      }
    </div>
  )
}


export default ConfirmModalMobile
